import { forwardRef, useCallback, useRef, useState } from 'react';
import { InputBaseComponentProps } from '@mui/material';
import { useFormikContext } from 'formik';
import { CreditCardSecret } from '@styles/InputStyles';
import { InputMask } from '../InputWithMask';
import { ITextInputProps, TextInput } from '../TextInput';

const CvvMask = forwardRef(({ onChange, ...other }: InputBaseComponentProps) => {
  const cvvMask = [/\d/, /\d/, /\d/, /\d/];

  return <InputMask {...other} mask={cvvMask} onChange={onChange} />;
});

export const CvvInput = (props: ITextInputProps) => {
  const ref = useRef<HTMLDivElement>();
  const [showSecret, setSecretStatus] = useState(false);
  const formik = useFormikContext();

  const handleClickOnSecret = useCallback(
    () => {
      setSecretStatus(false);

      ref.current?.querySelector('input')?.focus();
    },
    []
  );

  return (
    <div style={{ position: 'relative' }}>
      {showSecret && !props.error && <CreditCardSecret style={{ left: '8px' }} onClick={handleClickOnSecret}>
        {(props.value as string).split('').map(() => '*').join('')}
      </CreditCardSecret>}

      <TextInput 
        {...props} 
        fullWidth
        InputProps={{ inputComponent: CvvMask }}
        onFocus={() => setSecretStatus(false)}
        onBlur={event => {
          formik?.handleBlur?.(event);
          setSecretStatus(true);
        }}
      />
    </div>
  );
};

